import { Dropdown, type MenuProps } from 'antd';
import classNames from 'classnames';
import type React from 'react';
import { useState } from 'react';

import { IconMenu } from 'src/components/icons/icon-menu/icon-menu';
import { GAHeaderDimensionName, GAHeaderEvent } from 'src/constants';
import { sendGAEvent } from 'src/services/analytics/ga';

const AVIATRIX_PROD_URL = 'https://backoffice-web-nft-prod.aviatrix.bet';
const AVIATRIX_STAGING_URL = 'https://backoffice-web-nft-staging.aviatrix.work';

export const ProductsMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const items: MenuProps['items'] = [
    {
      label: (
        <div className="flex gap-x-10 px-4 py-7 items-center group-hover:font-medium">
          <img src="/assets/public/images/aviatrix-logo.webp" alt="logo" width={30} height={28} />
          <span>Aviatrix</span>
        </div>
      ),
      key: 'aviatrix',
      className: 'group',
      onClick: () => {
        window.open(
          import.meta.env.VITE_PROJECT_ENV === 'production' ? AVIATRIX_PROD_URL : AVIATRIX_STAGING_URL,
          '_blank',
        );
        sendGAEvent(GAHeaderEvent.HEADER_CLICKS, {
          [GAHeaderDimensionName.HEADER]: 'products_menu_aviatrix',
        });
      },
    },
    {
      label: (
        <div className="flex gap-x-10 px-4 py-7 items-center group-hover:font-medium">
          <img src="/assets/public/images/zing-logo.webp" alt="logo" width={30} height={28} />
          <span>Zing</span>
        </div>
      ),
      key: 'zing',
      className: 'group',
      onClick: () => {
        sendGAEvent(GAHeaderEvent.HEADER_CLICKS, {
          [GAHeaderDimensionName.HEADER]: 'products_menu_zing',
        });
      },
    },
  ];

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items }}
      classNames={{ root: 'min-w-[177px]' }}
      placement="bottomRight"
      onOpenChange={(open) => {
        setIsOpen(open);

        if (open) {
          sendGAEvent(GAHeaderEvent.HEADER_CLICKS, {
            [GAHeaderDimensionName.HEADER]: 'products_menu',
          });
        }
      }}
    >
      <div className="rounded-sm hover:bg-extra-gray-8 duration-100 cursor-pointer">
        <IconMenu className={classNames('duration-100', { 'text-gray-4': !isOpen, 'text-primary': isOpen })} />
      </div>
    </Dropdown>
  );
};
